// External Libraries
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import { Skeleton } from "primereact/skeleton";

interface UserSettings {
  isParticipantOfLeaderboard: boolean;
}

interface AnonymizationSettingsProps {
  userSettings: UserSettings | null;
  onCheckboxChange: (attr: keyof UserSettings, checked: boolean) => void;
}

export function AnonymizationSettings({
  userSettings,
  onCheckboxChange,
}: AnonymizationSettingsProps) {
  if (!userSettings) {
    return (
      <div aria-busy="true" aria-label="Loading settings">
        <Skeleton width="25%" height="2rem" />
        <Skeleton width="25%" height="2rem" />
      </div>
    );
  }

  const { isParticipantOfLeaderboard } = userSettings;

  return (
    <div className="flex items-start gap-3" data-testid="anonymization-settings">
      <Checkbox
        inputId="leaderboard"
        checked={isParticipantOfLeaderboard}
        onChange={(e: CheckboxChangeEvent) =>
          onCheckboxChange("isParticipantOfLeaderboard", e.checked ?? false)
        }
        aria-describedby="leaderboard-desc"
        pt={{ input: { "data-testid": "anonymization-leaderboard-checkbox" } }}
      />
      <div>
        <label htmlFor="leaderboard">Participate in the leaderboard.</label>
        <p id="leaderboard-desc" className="body-sm text-muted-aaa">
          Your name, profile picture, and points status will be shown.
        </p>
      </div>
    </div>
  );
}
